/* tslint:disable */

declare var Object: any;
export interface CommissionInterface {
  "id"?: number;
}

export class Commission implements CommissionInterface {
  "id": number;
  constructor(data?: CommissionInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Commission`.
   */
  public static getModelName() {
    return "Commission";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Commission for dynamic purposes.
  **/
  public static factory(data: CommissionInterface): Commission{
    return new Commission(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Commission',
      plural: 'Commissions',
      path: 'Commissions',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
